import { create } from 'zustand';

import { UserInfo } from '@/slw/shared/types/auth.type';
import { onlineStatusService } from '@/slw/shared/lib/firebase/online-status';

interface AuthStoreState {
  user: UserInfo;
  setUser: (user: UserInfo) => void;
  clearUser: () => void;
  setOnlineStatus: (userId: string) => void;
  setOfflineStatus: (userId: string) => void;
  fcmToken: string;
  setFcmToken: (fcmToken: string) => void;
}

const initialUser: UserInfo = {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  zipCode: '',
  countryCode: '',
  countryName: '',
  city: '',
  stateCode: '',
  stateName: '',
  isDealer: false,
};

export const useAuthStore = create<AuthStoreState>()((set) => ({
  user: { ...initialUser },
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: { ...initialUser } }),
  setOnlineStatus: (userId) => {
    if (userId) {
      onlineStatusService.setupOnlineStatus(userId);
    }
  },
  setOfflineStatus: (userId) => {
    if (userId) {
      onlineStatusService.setOfflineStatus(userId);
    }
  },
  fcmToken: '',
  setFcmToken: (fcmToken) => set({ fcmToken }),
}));
